export default "__VITE_ASSET__BLmwlX4p__"